import { render, staticRenderFns } from "./Suggestion.vue?vue&type=template&id=083a9225&"
import script from "./Suggestion.vue?vue&type=script&lang=js&"
export * from "./Suggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports